// import React, { useEffect, useState } from 'react';
// import { Navbar, Nav, Form, NavDropdown } from 'react-bootstrap';
// import './Header.css'; // Import the CSS file for custom styles
// import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import { useNavigate } from 'react-router-dom';
// import { Heart, RefreshCcw, MapPin, Phone } from 'lucide-react';

// const Header = () => {
//   const navigate = useNavigate();
//   const [carttotalprice, setCartTotalPrice] = useState(0.00);
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track hamburger menu
//   const [toSearch, setToSearch] = useState("");
//   const [width, setWidth] = useState(window.innerWidth);
//   const categories = [
//     "Mobile & Tab",
//     "Mobile Accessories",
//     "Computer & Laptop",
//     "Computer & Laptop Accessories",
//     "TV & Home Entertainment",
//     "Kitchen Appliances",
//     "Home Appliances",
//     "Refrigerators",
//     "Audio",
//     "Camera",
//   ];

//   useEffect(() => {
//     const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
//     if (cartItems.length > 0) {
//       let total = 0.00;
//       cartItems.forEach((item) => {
//         total += item.price * item.quantity;
//       });
//       total = total.toFixed(2);
//       setCartTotalPrice(total);
//     } else {
//       setCartTotalPrice(0.00);
//     }
//     const handleResize = () => setWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//   }, []);

//   function handleSearch() {
//     if (toSearch === "") return;
//     navigate(`/search/${toSearch}`);
//   }
//   return (
//     <>
//       <Navbar
//         bg=""
//         expand="lg"
//         className="custom-navbar"
//         onToggle={(isOpen) => setIsMenuOpen(isOpen)} // Update state on toggle
//       >
//         <Navbar.Brand href="/" className="brand-name">
//           <div
//             style={{
//               fontSize: '2.3rem',
//               color: 'rgba(232, 53, 53, 0.963)',
//               fontFamily: 'Montserrat',
//               fontWeight: '800',
//             }}
//           >
//             KHOSLA
//           </div>
//           <div
//             style={{
//               fontSize: '1.5rem',
//               fontWeight: '800',
//               lineHeight: '1',
//               color: 'red',
//               marginTop: '-10px',
//             }}
//           >
//             ELECTRONICS
//           </div>
//         </Navbar.Brand>
//         <Navbar.Toggle
//           aria-controls="basic-navbar-nav"
//           onClick={() => setIsMenuOpen((prev) => !prev)} // Toggle state on click
//         />
//         <Navbar.Collapse
//           id="basic-navbar-nav"
//           className="justify-content-between"
//           in={isMenuOpen} // Control collapse state based on the variable
//         >
//           {
//             (width > 768) ? <>
//               <Nav className="mr-auto">
//                 <NavDropdown
//                   title={<span className="dropdown-title">Category</span>}
//                   id="basic-nav-dropdown"
//                   className="category-dropdown"
//                 >
//                   {categories.map((category, index) => (
//                     <NavDropdown.Item
//                       key={index}
//                       className="dropdown-item-custom"
//                       onClick={() => navigate(`/category/${category}`)}
//                     >
//                       {category}
//                     </NavDropdown.Item>
//                   ))}
//                 </NavDropdown>
//               </Nav>
//               <Form inline className="search-form">
//                 <div className="search-bar-wrapper">
//                   <input
//                     type="text"
//                     placeholder="Search here..."
//                     className="search-bar"
//                     onChange={(e) => setToSearch(e.target.value)}
//                   />
//                   <i className="fas fa-search search-icon" onClick={handleSearch}></i>
//                 </div>
//               </Form>
//               <Nav className="nav-icons">
//                 <Nav.Link href="/wishlist">
//                   <i className="far fa-heart" aria-hidden="true"></i>
//                 </Nav.Link>
//                 <Nav.Link href="/compare">
//                   <i className="fas fa-exchange-alt"></i>
//                 </Nav.Link>
//                 <Nav.Link className='header-cart-price' onClick={() => navigate('/cart')}>
//                   <AddShoppingCartIcon
//                     style={{ color: 'red' }}
//                   />
//                   ₹{carttotalprice}
//                 </Nav.Link>
//               </Nav>
//               <Nav
//                 className="contact-info"
//                 style={{ display: 'flex', flexDirection: 'column' }}
//               >
//                 <Nav.Link
//                   href="tel:+919511943020"
//                   className="contact-item"
//                 >
//                   <i className="fas fa-headset"></i>
//                   <span className="contact-text">
//                     <span style={{ color: 'GrayText' }}>Support</span> +91 9511943020
//                   </span>
//                 </Nav.Link>
//                 <Nav.Link
//                   href="mailto:khoslaonline@khoslaelectronics.com"
//                   className="contact-item email-item"
//                   style={{ marginTop: '-20px' }}
//                 >
//                   <span className="contact-text">
//                     khoslaonline@khoslaelectronics.com
//                   </span>
//                 </Nav.Link>
//               </Nav>

//             </> : null
//           }

//         </Navbar.Collapse>
//       </Navbar>

//       {
//         isMenuOpen && <div className='header-sidebar'>

//           <p onClick={() => setIsMenuOpen(false)}>X</p>
//           <h3>Categories</h3>
//           {
//             categories.map((category, index) => (
//               <button key={index} onClick={() => navigate(`/category/${category}`)}>{category}</button>
//             ))
//           }

//           <h4>Compare <RefreshCcw color='rgb(207, 46, 46)' onClick={() => navigate('/compare')} /></h4>
//           <h4>Wishlist <Heart color='rgb(207, 46, 46)' /></h4>
//           <h4>Stores <MapPin color='rgb(207, 46, 46)' onClick={() => navigate('/store-locator')} /></h4>
//           <h4>Contact Us <Phone color='rgb(207, 46, 46)' onClick={() => navigate('/contact-us')} /></h4>
//         </div>
//       }

//     </>
//   );
// };

// export default Header;


import React, { useEffect, useState } from "react";
import { Search, Heart, RefreshCcw, ShoppingCart, Headphones, Menu, MapPin, Phone } from "lucide-react";
import "./headerpage.css"; // Import CSS
import { useNavigate } from "react-router-dom";
import {CircularProgress} from '@mui/material';

function Header() {
  const navigate = useNavigate();
  const [carttotalprice, setCartTotalPrice] = useState(0.00);
  const [cartQuantity, setCartQuantity] = useState(0);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [products, setProducts] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const categories = [
        "Mobile & Tab",
        "Mobile Accessories",
        "Computer & Laptop",
        "Computer & Laptop Accessories",
        "TV & Home Entertainment",
        "Kitchen Appliances",
        "Home Appliances",
        "Refrigerators",
        "Audio",
        "Camera",
      ];

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    if (cart.length > 0) {
      let total = 0.00;
      cart.forEach((item) => {
        total += item.price * item.quantity;
      });
      total = total.toFixed(2);
      setCartTotalPrice(total);
      setCartQuantity(cart.length);
    }

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  }, [])

  function handleCategoryClick(event) {
    const selectedCategory = event.target.value;
    navigate(`/category/${selectedCategory}`);
  }

  const fetchProducts = async () => {
    try {
      // const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     queryStringParameters: {
      //       "field": "Description",
      //       "value": searchValue
      //     }
      //   }),
      // });
      const response = await fetch(
        `https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/excel-data?field=Description&value=${searchValue}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({})
        }
      )
      const data = await response.json();
      // if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
      //   //console.log("api data product search page:", data);
      //   const cleanedBody = data.body.replace(/NaN/g, 'null');
      //   const parsedData = JSON.parse(cleanedBody);
      //   //console.log("Parsed data product search page:", parsedData);
      //   return parsedData;
      // }
      if(response.ok){
        return data;
      }

      return [];
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  async function handleSeach(event) {
    setSearchValue(event.target.value);
    if (event.target.value === "") {
      setIsLoading(false);
      setShowSearchResults(false);
      setProducts([]);
      setSearchValue('');
    } else {
      //console.log("search value", searchValue);
      setIsLoading(true);
      const products = await fetchProducts();
      //console.log("products", products);
      if (products?.length > 0) {
        setProducts(products?.slice(0, 3));
        setShowSearchResults(true);
        setIsLoading(false);
      }
    }
  }


  return (
    <>
      <header className="Homepage-header">
        {/* Logo */}
        <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/01/KHOSLA_BOX_LOGO-e1669799861489-1.png" alt="KHOSLA ELECTRONIC" className="Homepage-logo" onClick={() => navigate("/")} />

        {
          (width > 768) ?
            <>
              {/* Category Dropdown */}
              <select className="Homepage-category" onChange={handleCategoryClick}>
                <option value="" disabled hidden selected>Category</option>
                <option value="mobile & tab">Mobile & Tab</option>
                <option value="mobile accessories">Mobile Accessories</option>
                <option value="computer & laptop">Computer & Laptop</option>
                <option value="computer & laptop accessories">Computer & Laptop Accessories</option>
                <option value="tv & home entertainment">TV & Home Entertainment</option>
                <option value="kitchen appliances">Kitchen Appliances</option>
                <option value="home appliances">Home Appliances</option>
                <option value="refrigerators">Refrigerators</option>
                <option value="audio">Audio</option>
                <option value="camera">Camera</option>
              </select>

              {/* Search Box */}
              <div className="Homepage-searchBox">
                <input type="text" placeholder="Search here..." className="Homepage-searchInput" onChange={handleSeach} />
                {
                  isLoading ? <CircularProgress color="inherit" size={20} style={{ marginRight: "1rem" }} /> : null
                }
                <Search className="Homepage-icon" onClick={() => navigate(`/search/${searchValue}`)} />
              </div>

              {/* Icons Section */}
              <div className="Homepage-icons">
                <Heart className="Homepage-icon" onClick={() => navigate('/wishlist')} />
                <RefreshCcw className="Homepage-icon" onClick={() => navigate('/compare')} />
                <span className="Homepage-price" onClick={() => navigate('/cart')}>₹{carttotalprice}</span>
                <div className="Homepage-cart" onClick={() => navigate('/cart')}>
                  <ShoppingCart className="Homepage-icon" />
                  <span className="Homepage-cartBadge">{cartQuantity}</span>
                </div>

              </div>

              {/* Support Section */}
              <div className="Homepage-support">
                <Headphones className="Homepage-icon" />
                <div>
                  <div className="Homepage-supportText-container">
                    <span className="Homepage-supportText">Support</span>
                    <br />
                    <span className="Homepage-contact" onClick={() => window.open('tel:+919511943020')}>+91 9511943020</span>
                    <br />
                  </div>
                  <span className="Homepage-email" onClick={() => window.open('mailto:khoslaonline@khoslaelectronics.com')}>khoslaonline@khoslaelectronics.com</span>
                </div>
              </div>
            </>
            :
            <div>
              <Menu size={40} onClick={() => setIsMenuOpen(true)}/>
            </div>

        }

      </header>

      {
        showSearchResults && (
          <div className="search-results">
            <div>
              {
                products?.map((product, index) => (
                  <div key={index} className="search-result-item" onClick={() => navigate(`/product/${product?.Model}`)}>
                    <img src={`https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}`} alt={product?.Name} />
                    <p>{product.Name}</p>
                  </div>
                ))
              }
            </div>
            <button onClick={() => navigate(`/search/${searchValue}`)}>
              View All
            </button>
          </div>
        )
      }

      {
        isMenuOpen && <div className='header-sidebar'>

          <p onClick={() => setIsMenuOpen(false)}>X</p>
          <h3>Categories</h3>
          {
            categories.map((category, index) => (
              <button key={index} onClick={() => navigate(`/category/${category}`)}>{category}</button>
            ))
          }

          <h4 onClick={() => navigate('/compare')}>Compare <RefreshCcw color='rgb(207, 46, 46)'/></h4>
          <h4 onClick={() => navigate('/wishlist')}>Wishlist <Heart color='rgb(207, 46, 46)' /></h4>
          <h4 onClick={() => navigate('/store-locator')}>Stores <MapPin color='rgb(207, 46, 46)'/></h4>
          <h4 onClick={() => navigate('/contact-us')}>Contact Us <Phone color='rgb(207, 46, 46)'/></h4>
        </div>
      }

    </>

  );
};

export default Header;
